module.exports = __webpack_public_path__ + "img/202208-prize.0a22eacd.jpg";